import styled from 'styled-components';
import RatingStarSvg from './../assets/rating-star.svg';

const RatingStarIcon = styled(RatingStarSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width};
  height: ${props => props.height};
  fill: ${props => props.fill};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default RatingStarIcon;
